<div class="header-row">
  <h2 *ngIf="!isMed">Kullanılmış Kazanımlar ({{ usedEarnings.length }})</h2>
  <h2 *ngIf="isMed">Kullanılmış Kazanımlar ({{ medEarnings.length }})</h2>
  <app-button text="Excel İndir" (click)="downloadExcel()"></app-button>
</div>

<div class="loader-container" *ngIf="loading">
  <app-loader></app-loader>
</div>

<table class="table table-hover table-bordered" *ngIf="!loading && !isMed">
  <thead>
    <tr>
      <th>Kod</th>
      <th>Kullanım Tarihi</th>
      <th>Kullanıcı Telefonu</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of usedEarnings">
      <td>{{ item.discountCode }}</td>
      <td>{{ item.usedDate | date: 'dd.MM.yyyy HH:mm' }}</td>
      <td>{{ item.userPhone }}</td>
    </tr>
  </tbody>
</table>

<table class="table table-hover table-bordered" *ngIf="isMed">
  <thead>
    <tr>
      <th>Kullanıcı Telefonu</th>
      <th>Kullanım Tarihi</th>
      <th>Ticari İleti Onayı</th>
      <th>Açık Rıza Onayı</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of medEarnings">
      <td>{{ item.userPhone }}</td>
      <td>{{ item.usedDate }}</td>
      <td>{{ item.ticariIletiOnayi }}</td>
      <td>{{ item.acikRizaOnayi }}</td>
    </tr>
  </tbody>
</table>

<p class="med-legal-notice" *ngIf="isMed">{{ medLegalNotice }}</p>
